<template>
  <Form :validation-schema="schema" @submit="onSubmit">
    <div v-for="option in options" :key="option">
      <div class="py-2">
        <label class="cursor-pointer">
          <div class="p-3 border border-gray-200 rounded-md">
            <div class="flex items-center">
              <Field name="selectedOption" type="checkbox" :value="option" class="w-5 h-5 border-gray-300 rounded focus:ring-slate-500 text-slate-600" />
              <div for="selectedOption" class="block ml-3 text-sm font-medium text-gray-700 dark:text-white">
                {{ option }}
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <ErrorMessage name="selectedOption" class="mt-1 text-sm text-red-500" />

    <div>
      <TaskSubmitButton :cta="'Submit'" :correct="answer.correct" @skip="$emit('skip', $event)" />
    </div>
  </Form>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import TaskSubmitButton from "../task/TaskSubmitButton.vue";
import isEqual from "lodash.isequal";
import { ref } from "vue";

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    TaskSubmitButton,
  },
  props: {
    options: Array,
    solution: Array,
  },

  setup(props, { emit }) {
    const answer = ref({
      item: null,
      correct: null,
    });
    const schema = ref({
      selectedOption: (value) => {
        if (value) {
          return true;
        }
        return "Please select your answer.";
      },
    });

    function onSubmit(e) {
      const solution = props.solution;
      // evaluate answer
      const correct = isEqual(e.selectedOption.sort(), solution.sort()) ? true : false;

      answer.value = {
        item: e.selectedOption,
        correct: correct,
      };

      emit("answer", answer.value);
    }
    return {
      answer,
      schema,
      onSubmit,
    };
  },
};
</script>
